export const galleryRows = [
  {
    items: [
      {
        image:
          "https://static.readdy.ai/image/309c8cd033c69b13958f82260e1bf6fe/db0121cb43be8f94c6206edf47493685.png",
        caption: "마음톡톡 콘서트",
      },
      {
        image:
          "https://static.readdy.ai/image/309c8cd033c69b13958f82260e1bf6fe/fca38e1e296c736a6f5dcdc29f861e7e.png",
        caption: "플리마켓",
      },
      {
        image:
          "https://static.readdy.ai/image/309c8cd033c69b13958f82260e1bf6fe/7cd1b6f3ccbce153ee8a0fc4ae176bbc.png",
        caption: "재능마켓",
      },
      {
        image:
          "https://static.wixstatic.com/media/17b604_16f81f9063b84f929ee8c5bc9c6c9ef4~mv2.jpg",
        caption: "소래찬 김장 한마당",
      },
    ],
  },
  {
    items: [
      {
        image:
          "https://static.wixstatic.com/media/17b604_610f67cef63a4d43a39893de79e3ead3~mv2.jpg",
        caption: "남동구 자원봉사자의 날 기념식",
      },
      {
        image:
          "https://static.wixstatic.com/media/17b604_c23d1d17004b40b69c0d905d879fd662~mv2.png",
        caption: "이웃사랑, 일일 찻집",
      },
      {
        image:
          "https://static.wixstatic.com/media/17b604_cb7ffc7d155045a4bc10e97805310ab6~mv2.png",
        caption: "2024 한마음 정기 모임",
      },
      {
        image:
          "https://static.wixstatic.com/media/17b604_6ee4210222af4b9096a9ed21593d6696~mv2.png",
        caption: "정기 총회 및 회장 취임식",
      },
    ],
  },
  {
    items: [
      {
        image:
          "https://static.wixstatic.com/media/17b604_9b11c76bd5cf426ca37ef23d57061159~mv2.jpg",
        caption: "음악 토크 콘서트",
      },
      {
        image:
          "https://static.wixstatic.com/media/17b604_060800dffd434d7297b9abbc063c0b31~mv2.jpg",
        caption: "한마음 봉사단 복장",
      },
      {
        image:
          "https://static.wixstatic.com/media/17b604_0c06373ef1114572b9c03e8d0679ef1e~mv2.jpg",
        caption: "남동구자원봉사센터 주관 병원동행 전문교육",
      },
      {
        image:
          "https://static.wixstatic.com/media/17b604_ed9e2d18dbc44c3d956e820c5d1641f9~mv2.png",
        caption: "인천 대공원 연합 봉사",
      },
    ],
  },
];